import { useEffect, useState } from "react";
import { Tooltip } from 'primereact/tooltip';

import CardSeplag from "../../components/CardSeplag";
import RotuloSeplag from "../../components/RotuloSeplag";
import { Button } from 'primereact/button';
import { useLocation } from 'react-router-dom'
import { useHistory } from "react-router-dom";

import { Form as initForm, buscarPorCodigo } from "../../service/certidao";


import { ErrorOutline, CheckCircleOutline } from '@material-ui/icons'

const Certidao = (props) => {

    const [certidao, setCertidao] = useState(props.certidao);
    const [valorLiquido, setValorLiquido] = useState(null);

    const history = useHistory();

    // useEffect(() => {

    //     buscarPorCodigo(props.certidao.idenCertidao).then(res => {
    //         setCertidao(res)
    //     })

    // }, []);

    useEffect(() => {
        if (certidao) {
            let somaValorLiquido = certidao.valrBruto
            if (certidao.valrEmolumento) {
                somaValorLiquido = somaValorLiquido - certidao.valrEmolumento
            }
            if (certidao.valrIr) {
                somaValorLiquido = somaValorLiquido - certidao.valrIr
            }
            if (certidao.valrHonorario) {
                somaValorLiquido = somaValorLiquido - certidao.valrHonorario
            }
            somaValorLiquido = formataDinheiro(somaValorLiquido)
            setValorLiquido(somaValorLiquido)
        }
    }, [certidao])

    const voltar = () => {
        history.push("/listaCertidao")
    };

    function formataDinheiro(n) {
        if (n) {
            return "R$ " + n.toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+\,)/g, "$1.");
        } else {
            return "Não Informado"
        }
    }

    function verificaData(data, textoRotulo) {
        if (data) {
            return data;
        } else {
            return "Não " + textoRotulo
        }
    }

    if (!certidao) {
        return <></>
    }
    return (
        <CardSeplag title="Detalhes Certidão de Crédito" >

            <RotuloSeplag nome="Nº Certidão de Crédito:" cols="12 6" >
                <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
                    {certidao.numrCertidao}
                </label>
            </RotuloSeplag>

            <RotuloSeplag nome="Status:" cols="12 6" >
                <div className='doisInputCertidao'>
                    <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
                        {certidao.statCertidao}
                    </label>
                    {/* <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'> 
                        {verificaData(certidao.dataSituacao)}
                    </label> */}
                </div>
            </RotuloSeplag>

            <RotuloSeplag nome="Tipo:" cols="12" >
                <div className='doisInputCertidao'>
                    {/* <label className='p-inputtext p-component p-disabled p-filled primeiroInputDoisCertidao'> 
                        {certidao.obrigacao.tipoCertidao.codgTipoCertidao}
                    </label>    */}
                    <label className='p-inputtext p-component p-disabled p-filled segundoInputDoisCertidao'>
                        {certidao.obrigacao.tipoCertidao.nomeTipoCertidao}
                    </label>
                </div>
            </RotuloSeplag>

            <RotuloSeplag nome="Data de Emissão:" cols="12 6" >
                <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
                    {verificaData(certidao.dataEmissao, 'está Emitido')}
                </label>
            </RotuloSeplag>
            <RotuloSeplag nome="Data da Validação Beneficiário:" cols="12 6" >
                <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
                    {verificaData(certidao.dataValidacaoBeneficiario, 'está Validado o Beneficiário')}
                </label>
            </RotuloSeplag>
            <RotuloSeplag nome="Data de Quitação:" cols="12 6" >
                <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
                    {verificaData(certidao.dataQuitacao, 'está Quitado')}
                </label>
            </RotuloSeplag>
            <RotuloSeplag nome="Data de Autenticação:" cols="12 6" >
                <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
                    {verificaData(certidao.dataAutenticacao, 'está Autenticado')}
                </label>
            </RotuloSeplag>

            <RotuloSeplag nome="Valor Bruto:" cols="12 3" >
                <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
                    {formataDinheiro(certidao.valrBruto)}
                </label>
            </RotuloSeplag>

            <RotuloSeplag nome="Valor Líquido:" cols="12 3" >
                <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
                    {valorLiquido}
                </label>
            </RotuloSeplag>


            <RotuloSeplag nome="Valor Emolumentos:" cols="12 3" >
                <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
                    {formataDinheiro(certidao.valrEmolumento)}
                </label>
            </RotuloSeplag>

            <RotuloSeplag nome="Valor I.R:" cols="12 3" >
                <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
                    {formataDinheiro(certidao.valrIr)}
                </label>
            </RotuloSeplag>
            <RotuloSeplag nome="Valor Honorário:" cols="12 6" >
                <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan' >
                    {formataDinheiro(certidao.valrHonorario)}
                </label>
            </RotuloSeplag>
            <div className='p-col-12 p-md-2'></div>

            <hr className='p-col-12' />

            <div className='p-col-12' style={{ display: 'flex', justifyContent: 'flex-start' }}>
                <h5> <strong>Titular</strong></h5>

                {
                    certidao.flagValidacaoBeneficiario == 'N'
                        ?
                        (<>
                            <Tooltip target=".tooltip-icon-warning" mouseTrack mouseTrackLeft={10} />
                            <ErrorOutline className='tooltip-icon-warning' style={{ color: '#e95c09', fontSize: '2rem' }} data-pr-tooltip="Titular não Validado" data-pr-position='top' />
                        </>)
                        : (<>
                            <Tooltip target=".tooltip-icon-success" mouseTrack mouseTrackLeft={10} />
                            <CheckCircleOutline className='tooltip-icon-success' style={{ color: '#067406', fontSize: '2rem' }} data-pr-tooltip="Titular Validado" data-pr-position='top' />
                        </>)
                }
            </div>

            <div className='p-col-12'></div>

            <RotuloSeplag nome="Beneficiário:" cols="12 4" >
                <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
                    {certidao.pessoa.nomePessoa}
                </label>
            </RotuloSeplag>
            <RotuloSeplag nome="CPF:" cols="12 4 " >
                <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
                    {certidao.pessoa.cpfFormatado}
                </label>
            </RotuloSeplag>
            <RotuloSeplag nome="RG:" cols="12 4 " >
                <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
                    {certidao.pessoa.numrRg}
                </label>
            </RotuloSeplag>
            <RotuloSeplag nome="Órgão Expedidor do RG:" cols="12 4 " >
                <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
                    {certidao.pessoa.clasOrgaoEmissorRg}
                </label>
            </RotuloSeplag>
            <RotuloSeplag nome="Unidade Federativa (UF):" cols="12 4 " >
                <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
                    {certidao.pessoa.ufRg?.siglUf}
                </label>
            </RotuloSeplag>
            <RotuloSeplag nome="Matrícula Beneficiário:" cols="12 4 " >
                <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
                    {certidao.pessoa.servidor.numrMatricula}
                </label>
            </RotuloSeplag>
            <RotuloSeplag nome="Órgão de Origem:" cols="12 4 " >
                <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
                    {certidao.obrigacao.orgao.descOrgao}
                </label>
            </RotuloSeplag>

            {/* <RotuloSeplag nome="Município:" cols="12 4 " >
                <label className='p-inputtext p-component p-disabled p-filled inputEditadonoSpan'>
                    {certidao.obrigacao.orgao.descOrgao}
                </label>
            </RotuloSeplag> */}

            {/* {flagAbrirModalBloquear && (<ModalBloqueioDesbloqueio titulo={'Bloquear ou Desbloquear Certidão'} certidao={certidao} visible={flagAbrirModalBloquear} onSalvar={handleSalvarModal} onFechar={fecharModalBloquear} tipoAcao={tipoAcao} />)}
            {flagAbrirModalAutenticar && (<ModalAutenticar titulo={'Autenticar Certidão'} visible={flagAbrirModalAutenticar} onFechar={fecharModalAutenticar} onSalvar={salvarModalAutenticar} tipoAcao={tipoAcao} />)}
            {flagAbrirModalValidarBeneficiario && (<ModalValidarBeneficiario certidao={certidao} titulo={'Validar Beneficiário'} visible={flagAbrirModalValidarBeneficiario} onSalvar={handleSalvarModal} onFechar={fecharModalValidarBeneficiario} tipoAcao={tipoAcao} />)}
            {flagAbrirModalCancelar && (<ModalCancelar titulo={'Cancelar Certidão'} certidao={certidao} visible={flagAbrirModalCancelar} onFechar={fecharModalCancelar} tipoAcao={tipoAcao} />)} */}

        </CardSeplag>
    )
}


export default Certidao;


// const ENUM_STATES = (props) => ({
//     validarBeneficiario: <Button label='Validar Beneficiário' onClick={props.handleModalValidarBeneficiario} className='p-col-12  p-md-3 botoesAcaoCertidao' icon="pi pi-user-edit" tooltip="Validar Beneficiário" tooltipOptions={{ position: 'right' }} />,
//     autenticar: <Button type="button" label='Autenticar' onClick={props.handleModalAutenticar} className='p-col-12 p-md-3  botoesAcaoCertidao autenticarEnabled' icon="pi pi-check-circle" tooltip="Realizar Autenticação" tooltipOptions={{ position: 'left' }} />,
//     compensacao: <Button label='Compensação' onClick={props.handleRegistrarCompensacao} className='p-col-12 p-md-3  botoesAcaoCertidao' icon="pi pi-dollar" />,
//     quitacao: <Button label='Quitação' onClick={props.handleRegistrarQuitacao} className='p-col-12 p-md-3  botoesAcaoCertidao' icon="pi pi-check" />,
//     cancelar: <Button label='Cancelar' onClick={props.handleModalCancelar} className='p-col-12 p-md-3  botoesAcaoCertidao' icon="pi pi-trash" />,
//     validarBeneficiarioDisabled: <Button label='Validar Beneficiário' className='p-col-12  p-md-3 botoesAcaoCertidao p-disabled' icon="pi pi-user-edit" tooltip="Beneficiário Validado ou Bloqueada" tooltipOptions={{ position: 'right' }} />,
//     autenticarDisabled: <Button type="button" label='Autenticar' className='p-col-12 p-md-3  botoesAcaoCertidao p-disabled' icon="pi pi-check-circle" tooltip="Certidão Autenticada ou Bloqueada" tooltipOptions={{ position: 'left' }} />,
//     compensacaoDisabled: <Button label='Compensação' className='p-col-12 p-md-3  botoesAcaoCertidao p-disabled' icon="pi pi-dollar" />,
//     quitacaoDisabled: <Button label='Quitação' className='p-col-12 p-md-3  botoesAcaoCertidao p-disabled' icon="pi pi-check" />,
//     cancelarDisabled: <Button label='Cancelar' className='p-col-12 p-md-3  botoesAcaoCertidao p-disabled' icon="pi pi-trash" />,
// });

// function ButtonState({ state, flagSituacao, flagAutenticacao, flagValidacaoBeneficiario, ...props }) {

//     if (flagSituacao == 'BLOQUEADA') {
//         switch (state) {
//             case 'autenticar':
//                 return flagAutenticacao == 'S' ? ENUM_STATES(props)[`${state}Disabled`] : ENUM_STATES(props)[`${state}`]
//             // case 'validarBeneficiario':
//             //     return flagValidacaoBeneficiario == 'S' ? ENUM_STATES(props)[`${state}Disabled`] : ENUM_STATES(props)[`${state}`]
//             default:
//                 return ENUM_STATES(props)[`${state}Disabled`]
//         }

//     } else {
//         switch (state) {
//             case 'autenticar':
//                 return flagAutenticacao == 'S' ? ENUM_STATES(props)[`${state}Disabled`] : ENUM_STATES(props)[`${state}`]
//             case 'validarBeneficiario':
//                 return flagValidacaoBeneficiario == 'S' ? ENUM_STATES(props)[`${state}Disabled`] : ENUM_STATES(props)[`${state}`]
//             default:
//                 return ENUM_STATES(props)[`${state}`]
//         }
//     }
// }